import { render, staticRenderFns } from "./MemberTransferRecord.vue?vue&type=template&id=3b365cab&scoped=true&"
import script from "./MemberTransferRecord.vue?vue&type=script&lang=js&"
export * from "./MemberTransferRecord.vue?vue&type=script&lang=js&"
import style0 from "./MemberTransferRecord.vue?vue&type=style&index=0&id=3b365cab&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b365cab",
  null
  
)

export default component.exports